import { defineTokens } from '@chakra-ui/react';

/**
 * Кривые ускорения. Сток Chakra повторял дефолты CSS слово в слово: `ease-out` был
 * `cubic-bezier(0, 0, 0.58, 1)`, то есть ровно то, что браузер и так понимает под `ease-out`.
 * Такая кривая раскачивается на старте, и переход в 300ms читается как задержка отклика,
 * хотя длительность честная.
 *
 * Здесь кривые сильнее: движение срывается с места сразу и мягко тормозит. Время не менялось
 * ни у одного перехода, изменился только характер.
 *
 * Что чем:
 *
 * - `ease-out` — всё, что появляется и исчезает, и отклик на нажатие. Это девять переходов
 *   из десяти: меню, поповер, тултип, подсветка, проседание кнопки.
 * - `ease-in-out` — то, что уже на экране и переезжает с места на место: подчёркивание
 *   вкладки, ползунок переключателя.
 * - `ease-in-smooth` — шторка снизу, кривая из Ionic. Была здесь до этой правки и осталась
 *   без изменений: она единственная была подобрана, а не взята из дефолтов.
 *
 * `ease-in` удалён намеренно. Он начинает медленно, а это ровно тот момент, на который
 * смотрит человек, нажавший кнопку: интерфейс кажется неотзывчивым при той же длительности.
 * Единственное место, где он стоял (всплывающее уведомление), переведено на `ease-out`.
 */
export const easings = defineTokens.easings({
  // Ambient closed loops keep a constant speed across their cycle boundary.
  linear: {
    value: 'linear',
  },
  'ease-out': {
    value: 'cubic-bezier(0.23, 1, 0.32, 1)',
  },
  'ease-in-out': {
    value: 'cubic-bezier(0.77, 0, 0.175, 1)',
  },
  'ease-in-smooth': {
    value: 'cubic-bezier(0.32, 0.72, 0, 1)',
  },
});
